export default "__VITE_ASSET__ux4MxLdX__"